import Vue from "vue";
import { Route, RawLocation } from "vue-router";
import * as url from "url";
import Log from "@/components/log";
// import store from '@/store';
import { CoreModule } from "@/store/modules/core";
import {Dialog} from "vant";
import { vueRouterBase as weVueRouterBase } from "@/router";
import watermark from "watermark-dom";
import { debug } from "util";

export type ScopeType =
  | "snsapi_base"
  | "snsapi_userinfo"
  | "snsapi_privateinfo";

interface WechatConfig {
  appId: string;
  scope: ScopeType;
  authorize: (code: string) => Promise<any>;
  state?: string;
  registerPage?: string;
  registerMsg?: string;
  autoAuthPage?: string;
  autoAuthMsg?: string;
  agentid?: string;
  bindUserPage?: string;
  bindUserMsg?: string;
}

const defaultConfig = {
  state: "",
  registerPage: "/register",
  registerMsg: "本功能需要注册用户,是否跳转",
  autoAuthPage: "/autoAuth",
  autoAuthMsg: "授权已失效,是否授权",
  bindUserPage: "/bindUser",
  bindUserMsg: "本功能需要绑定用户,是否跳转",
};
// 去掉最后的'/'
const vueRouterBase = (weVueRouterBase as string).substr(
  0,
  (weVueRouterBase as string).length - 1
);
export default class WechatAuth {
  public wechatConfig: WechatConfig;

  constructor(config: WechatConfig) {
    this.wechatConfig = Object.assign(defaultConfig, config);
  }

  public isAuthed(): boolean {
    // const weUser: WeUser = (store.state as any).core.auth as WeUser;
    const weUser: WeUser = CoreModule.auth as WeUser;
    if (!weUser) {
      return false;
    }
    if (weUser.expire) {
      const flag = weUser.expire > new Date().getTime();
      if (!flag) {
        CoreModule.clearAuth();
      }
      return flag;
    }
    return false;
  }

  public isRegister(): boolean {
    // const weUser: WeUser = (store.state as any).core.auth as WeUser;
    const weUser: WeUser = CoreModule.auth as WeUser;
    // return weUser.register;
    return weUser.needReg ? weUser.register : true;
  }

  public isBindUser(): boolean {
    // const weUser: WeUser = (store.state as any).core.auth as WeUser;
    const weUser: WeUser = CoreModule.auth as WeUser;
    return weUser.needBind ? weUser.bindUser : true;
  }

  public routerBeforeGuards(
    to: Route,
    from: Route,
    next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void
  ) {
    const urlObj = url.parse(window.location.href, true);
    if ((to.meta as any).auth) {
      // const urlObj = url.parse(window.location.href, true);
      if (!this.isAuthed()) {
        if (urlObj.query && !urlObj.query.code) {
          // delete state in query in url
          delete urlObj.query.state;
          delete urlObj.search;
          //  跳转微信认证
          Log.info(urlObj);
          delete urlObj.path;
          delete urlObj.href;
          urlObj.pathname = vueRouterBase + to.path;
          urlObj.query = to.query as any;
          return this.redirect(url.format(urlObj), next);
        }
        // 继续微信回调带CODE流程
      } else if ((to.meta as any).auth === "user" && !this.isRegister()) {
        // 需要用户注册后

        Dialog.confirm({
          title: "注意",
          message: this.wechatConfig.registerMsg,
        })
          .then(() => {
            next(this.wechatConfig.registerPage);
          })
          .catch(() => {
            next(false);
          });
        return;
      } else if ((to.meta as any).auth === "user" && !this.isBindUser()) {
        Dialog.confirm({
          title: "注意",
          message: this.wechatConfig.bindUserMsg,
        })
          .then(() => {
            next(this.wechatConfig.bindUserPage);
          })
          .catch(() => {
            next(false);
          });
        return;
      }  else {
        // 正常流程
        this.storeWxUrl(to, urlObj);
        next();
        // watermark.load();
        // if (to.meta.watermark && localStorage.getItem("userInfo")) {
        //   watermark.load({
        //     watermark_txt: JSON.parse(localStorage.getItem("userInfo") as string).user_name
        //      + JSON.parse(localStorage.getItem("userInfo") as string).phone.substr(7)
        //    });
        // } else {
        //   watermark.remove();
        // }
        return;
      }

      try {
        // if options.authorize use callback
        const code: string = urlObj.query.code as string;
        const promise: Promise<any> = this.wechatConfig.authorize(code);
        promise
          .then((response: any) => {
            // store.commit('putAuth', response.data);
            CoreModule.putAuth(response.data);
            delete to.query.code;
            delete to.query.state;

            delete urlObj.query.code;
            delete urlObj.query.state;
            const fullpath = url.format(urlObj);

            // window.history.replaceState({ key: new Date().getTime() }, '', fullpath);
            if (!this.isAuthed()) {
              Dialog.confirm({
                title: "注意",
                message: "认证检验时间不正确",
              })
                .then(() => {
                  CoreModule.clearAuth();
                })
                .finally(() => {
                  next();
                });
            } else {
              next({
                path: to.path,
                query: to.query,
                params: to.params,
                replace: true,
              });
            }

            // watermark.load();
            // localStorage.setItem("userInfo", JSON.stringify(response.data.wxCorpUser));
            // if (to.meta.watermark) {
            //     watermark.load({
            //       watermark_txt: JSON.parse(localStorage.getItem("userInfo") as string).user_name
            //        + JSON.parse(localStorage.getItem("userInfo") as string).phone.substr(7)
            //      });
            //   } else {
            //     watermark.remove();
            //   }
          })
          .catch((e) => next(this.dealAuthError(e)));
      } catch (e) {
        next(this.dealAuthError(e));
      }
    } else {
      this.storeWxUrl(to, urlObj);
      next();
      // watermark.load();
      // if (to.meta.watermark && localStorage.getItem("userInfo")) {
      //   watermark.load({
      //     watermark_txt: JSON.parse(localStorage.getItem("userInfo") as string).user_name
      //      + JSON.parse(localStorage.getItem("userInfo") as string).phone.substr(7)
      //    });
      // } else {
      //   watermark.remove();
      // }
    }
  }

  protected dealAuthError(error: any) {
    // debugger
    error.errType = 'AuthError';
    return error;
  }

  protected storeWxUrl(to: any, urlObj: any) {
    if (to.path !== this.wechatConfig.autoAuthPage && to.path !== "/error") {
      CoreModule.storeRoute(to.fullPath);
    }
    // store.commit('setWxUrl', this.getWechatSignUrl(to, urlObj));
    CoreModule.setWxUrl(this.getWechatSignUrl(to, urlObj));
  }

  /**
   * redirect to wechat auth redirect_uri
   * @param {*} redirectUri
   */
  private redirect(
    redirectUri: string,
    next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void
  ) {
    const options = this.wechatConfig;
    let weixin = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
      options.appId
    }&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&response_type=code&scope=${options.scope}&state=${
      options.state
    }#wechat_redirect`;

    if (options.agentid) {
      weixin = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
        options.appId
      }&redirect_uri=${encodeURIComponent(
        redirectUri
      )}&response_type=code&scope=${options.scope}&agentid=${
        options.agentid
      }&state=${options.state}#wechat_redirect`;
    }
    next(false);
    window.location.replace(weixin);
    // next( () => {
    //   window.location.replace(weixin);
    //   return false;
    // });
  }

  // add for jssdk
  private isIos(): boolean {
    const u = navigator.userAgent;
    return u.indexOf("iPhone") > -1 || u.indexOf("Mac OS") > -1;
  }

  // add for jssdk
  private getWechatSignUrl(
    to: Route,
    urlQuery: url.UrlWithParsedQuery
  ): { wxUrl: string; ios: boolean } {
    if (this.isIos()) {
      return { wxUrl: window.location.href, ios: true };
    } else {
      const andorid = Object.assign({}, urlQuery);
      delete andorid.path;
      delete andorid.search;
      andorid.pathname = vueRouterBase + to.path;
      andorid.query = to.query as any;
      return { wxUrl: url.format(andorid), ios: false };
    }
  }
}

export interface WeUser {
  authorization: string;
  expire: number;
  register: boolean;
  bindUser: boolean;
  needReg: boolean;
  needBind: boolean;
}
